
import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListPaymentRequest extends Vue {
    @Prop({default: {}})
    private listPaymentRequest: any;

    private async viewDetail(paymentRequest: any) {
        const routeData = this.$router.resolve({ name: 'payment-request-detail', params: { id: paymentRequest.id.toString() } });
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }
}
